import React, { Component } from "react";
import { connect } from "react-redux";
import CircularSlider from "@fseehawer/react-circular-slider";
import Proptypes from "prop-types";
import ToggleSwitch from "../../common/toggleSwitch/";
import "./Tuners.styles.scss";

class Tuners extends Component {
  state = {
    max_value: 0,
    min_return: 0,
    upper_bound: 0,
    max_beta: 0,
    max_beta_subheading: "",
  };

  componentWillMount() {
    this.setTunersData(this.props);
  }
  componentDidMount() {
    this.setTunersData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.slected_obj) !==
      JSON.stringify(nextProps.slected_obj)
    ) {
      this.setTunersData(nextProps);
    }
  }

  setTunersData = (props) => {
    const { slected_obj, optimization_params, activePortfolioID } = props;
    if (slected_obj && Object.keys(slected_obj).length > 0) {
      let max_value =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["max_vol"]
          ? optimization_params[activePortfolioID]["max_vol"]
          : 0;

      let min_return =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["min_return"]
          ? optimization_params[activePortfolioID]["min_return"]
          : 0;

      let upper_bound =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["upper_bounds"]
          ? optimization_params[activePortfolioID]["upper_bounds"]
          : 0;

      let max_beta_value =
        activePortfolioID &&
        optimization_params[activePortfolioID] &&
        optimization_params[activePortfolioID]["max_beta"]
          ? optimization_params[activePortfolioID]["max_beta"]
          : 0;
      max_beta_value = +(max_beta_value * 1).toFixed(2);
      let max_beta = Array.from({ length: 301 }, (v, k) => k / 100).indexOf(
        max_beta_value
      );

      let _max_beta_value = slected_obj["max_beta"]
        ? slected_obj["max_beta"]
        : 0;
      _max_beta_value = +(_max_beta_value * 1).toFixed(2);

      let value = `${
        +_max_beta_value - 0.1 < 0 ? 0 : (_max_beta_value - 0.1).toFixed(2)
      } - ${
        +_max_beta_value + 0.1 > 3 ? 3 : (_max_beta_value + 0.1).toFixed(2)
      }`;

      this.setState({
        max_value: max_value < 0 ? 0 : max_value,
        min_return: min_return < 0 ? 0 : min_return,
        upper_bound: upper_bound < 0 ? 0 : upper_bound,
        max_beta: max_beta < 0 ? 0 : max_beta,
        max_beta_subheading: value,
      });
    }
  };

  volatilitySliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length - 1) * 1;

    if (value >= 0) {
      this.props.changeUIParams(
        ["optimization_params", "max_vol"],
        +value,
        +ID
      );
    } else return;
  };

  returnSliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length - 1) * 1;
    if (value >= 0) {
      this.props.changeUIParams(
        ["optimization_params", "min_return"],
        +value,
        +ID
      );
    } else return;
  };

  maxLimitSliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length - 1) * 1;
    if (value >= 0) {
      this.props.changeUIParams(
        ["optimization_params", "upper_bounds"],
        +value,
        +ID
      );
    } else return;
  };

  maxBetaSliderHandler = (value) => {
    const ID = this.props.activePortfolioID;
    value = value.substring(0, value.length) * 1;
    if (!value) return;
    this.props.changeUIParams(["optimization_params", "max_beta"], +value, +ID);
  };
  render() {
    const {
      securityUniverseActive,
      selected_type,
      absoluteSwitchHandler,
      absolute_max_vol,
      absolute_min_return,
      absolute_max_beta,
    } = this.props;

    const {
      max_beta_subheading,
      max_value,
      min_return,
      upper_bound,
      max_beta,
    } = this.state;

    let all_toggle_condition =
      absolute_max_vol === false &&
      absolute_min_return === false &&
      absolute_max_beta === false;

    return (
      <div className="tuners">
        <div>
          <div className="tuners_head">
            <div className="tuners_head_img">
              <img src="/images/tuners.png" alt="iqcio tuner" />
            </div>
            <div className="tuners_head_content text-uppercase">
              <div className="tuners_head_content_head1">Tuning parameters</div>
              <div className="tuners_head_content_head2">
                Fine tune some of the parameters that goes in as inputs to our
                AI models
              </div>
            </div>
          </div>
          <p>
            Althrough we recommend that you leave the model tuning parameters at
            defaults, you could fine tune some of the parameters that goes into
            our proprietary AI Models. Please adjust the parameters noted below
            to suite your needs.
          </p>
        </div>
        <div className="tuners_list">
          <div
            className={`tuners_list_card ${
              !absolute_max_vol && all_toggle_condition === false
                ? "tuners_pointer_none"
                : ""
            }`}
          >
            <div className="tuners_list_card_heading text-uppercase">
              Volatility
            </div>
            <div className="tuners_list_card_content">
              <p>
                Protect the portfolio from high volatility securities over a
                long duration of time
              </p>
              <p>
                You can specify the volatility percentage to fine tune the list
                of securities to use for the model
              </p>
            </div>
            <CircularSlider
              label="volatility"
              // appendToValue="%"
              labelFontSize="0px"
              labelColor={
                all_toggle_condition
                  ? "#3c548e"
                  : !absolute_max_vol
                  ? "#bbb"
                  : "#3c548e"
              }
              knobColor={
                all_toggle_condition
                  ? "#3c548e"
                  : !absolute_max_vol
                  ? "#bbb"
                  : "#3c548e"
              }
              progressColorFrom={
                all_toggle_condition
                  ? "#3bcbe3"
                  : !absolute_max_vol
                  ? "#bbb"
                  : "#3bcbe3"
              }
              progressColorTo={
                all_toggle_condition
                  ? "#3bcbe8"
                  : !absolute_max_vol
                  ? "#bbb"
                  : "#3bcbe8"
              }
              trackColor="#eeeeee"
              verticalOffset="-0.018em"
              progressSize={18}
              trackSize={18}
              min={0}
              data={Array.from({ length: 101 }, (v, k) => k + "%")}
              // max={100}
              dataIndex={max_value}
              onChange={(value) => {
                this.volatilitySliderHandler(value);
              }}
              width={150}
            />
            <div className="tuners_list_card_switch">
              <ToggleSwitch
                id="tuners_vol"
                checked={absolute_max_vol ? true : false}
                handler={() =>
                  absoluteSwitchHandler({
                    name: "max_vol",
                    value: !absolute_max_vol,
                  })
                }
                text_on="ABSOLUTE"
                text_off="ABSOLUTE"
                size="big"
                grey={
                  absolute_max_vol === false && selected_type === ""
                    ? true
                    : !absolute_max_vol
                    ? true
                    : false
                }
              />
            </div>
            {/* <div className="tuners_list_card_slider">
              <div onClick={() => this.onSliderChange(activePortfolioID, 0)}>
                <div id={`volatility${activePortfolioID}`} />
              </div>
            </div> */}
          </div>
          <div
            className={`tuners_list_card ${
              !absolute_min_return && all_toggle_condition === false
                ? "tuners_pointer_none"
                : ""
            }`}
          >
            <div className="tuners_list_card_heading text-uppercase">
              Return
            </div>
            <div className="tuners_list_card_content">
              <p>
                Calibrate and pick only those stocks that meet certain returns
                criteria and avoid high risk returns
              </p>
              <p>
                You can specify the returns percentage to fine tune the list of
                securities to use for the model
              </p>
            </div>
            <CircularSlider
              label="return"
              labelFontSize="0px"
              labelColor={
                all_toggle_condition
                  ? "#3c548e"
                  : !absolute_min_return
                  ? "#bbb"
                  : "#3c548e"
              }
              knobColor={
                all_toggle_condition
                  ? "#3c548e"
                  : !absolute_min_return
                  ? "#bbb"
                  : "#3c548e"
              }
              progressColorFrom={
                all_toggle_condition
                  ? "#3bcbe3"
                  : !absolute_min_return
                  ? "#bbb"
                  : "#3bcbe3"
              }
              progressColorTo={
                all_toggle_condition
                  ? "#3bcbe8"
                  : !absolute_min_return
                  ? "#bbb"
                  : "#3bcbe8"
              }
              verticalOffset="-0.018em"
              progressSize={18}
              trackColor="#eeeeee"
              trackSize={18}
              min={0}
              data={Array.from({ length: 101 }, (v, k) => k + "%")}
              // max={100}
              dataIndex={min_return}
              // appendToValue="%"
              onChange={(value) => {
                this.returnSliderHandler(value);
              }}
              width={150}
            />
            <div className="tuners_list_card_switch">
              <ToggleSwitch
                id="tuners_return"
                checked={absolute_min_return ? true : false}
                handler={() =>
                  absoluteSwitchHandler({
                    name: "min_return",
                    value: !absolute_min_return,
                  })
                }
                text_on="ABSOLUTE"
                text_off="ABSOLUTE"
                size="big"
                grey={
                  absolute_min_return === false && selected_type === ""
                    ? true
                    : !absolute_min_return
                    ? true
                    : false
                }
              />
            </div>

            {/* <div className="tuners_list_card_slider">
              <div onClick={() => this.onSliderChange(activePortfolioID, 1)}>
                <div id={`return${activePortfolioID}`} />
              </div>
            </div> */}
          </div>
          <div className="tuners_list_card">
            <div className="tuners_list_card_heading text-uppercase">
              {" "}
              Max Limit
            </div>
            <div className="tuners_list_card_content">
              {securityUniverseActive ? (
                <p>Avoid concentration risk at an security level</p>
              ) : (
                <p>
                  Avoid concentration risk at an asset class, classification,
                  fund type and style basis
                </p>
              )}

              {securityUniverseActive ? (
                <p style={{ marginBottom: "40px" }}>
                  You can specify the max limit percentage to fine tune the
                  securities to use for the model
                </p>
              ) : (
                <p>
                  You can specify the max limit percentage to fine tune the
                  security types to use for the model
                </p>
              )}
            </div>
            <CircularSlider
              label="max limit"
              // appendToValue="%"
              labelColor={"#3c548e"}
              labelFontSize="0px"
              knobColor={"#3c548e"}
              progressColorFrom={"#3bcbe3"}
              progressColorTo={"#3bcbe8"}
              verticalOffset="-0.018em"
              progressSize={18}
              trackColor="#eeeeee"
              trackSize={18}
              min={0}
              // max={100}
              data={Array.from({ length: 101 }, (v, k) => k + "%")}
              dataIndex={upper_bound}
              onChange={(value) => {
                this.maxLimitSliderHandler(value);
              }}
              width={150}
            />
            {/* <div className="tuners_list_card_slider">
              <div onClick={() => this.onSliderChange(activePortfolioID, 2)}>
                <div id={`limit${activePortfolioID}`} />
              </div>
            </div> */}
          </div>
          <div
            className={`tuners_list_card ${
              !absolute_max_beta && all_toggle_condition === false
                ? "tuners_pointer_none"
                : ""
            }`}
          >
            <div className="tuners_list_card_heading text-uppercase">
              Max Beta
            </div>
            <div className="tuners_list_card_content">
              <p>
                Curate the list of securities based on its Beta performance,
                relative to the underlying benchmark
              </p>
              <p>
                You can specify the max benchmark percentage to fine tune the
                list of securities to use for the model
              </p>
            </div>

            <CircularSlider
              label={max_beta_subheading}
              // give 10px labelFontSize to see maxBeta +.1 and -.1 value in subHeading
              labelFontSize="0px"
              labelBottom={true}
              // appendToValue="%"
              labelColor={
                all_toggle_condition
                  ? "#3c548e"
                  : !absolute_max_beta
                  ? "#bbb"
                  : "#3c548e"
              }
              knobColor={
                all_toggle_condition
                  ? "#3c548e"
                  : !absolute_max_beta
                  ? "#bbb"
                  : "#3c548e"
              }
              progressColorFrom={
                all_toggle_condition
                  ? "#3bcbe3"
                  : !absolute_max_beta
                  ? "#bbb"
                  : "#3bcbe3"
              }
              progressColorTo={
                all_toggle_condition
                  ? "#3bcbe8"
                  : !absolute_max_beta
                  ? "#bbb"
                  : "#3bcbe8"
              }
              verticalOffset="-0.018em"
              progressSize={18}
              trackColor="#eeeeee"
              trackSize={18}
              min={0}
              data={Array.from({ length: 301 }, (v, k) => k / 100 + "")}
              dataIndex={max_beta}
              onChange={(value) => {
                this.maxBetaSliderHandler(value);
              }}
              // valueFontSize={"3rem"}
              width={150}
            />
            <div className="tuners_list_card_switch">
              <ToggleSwitch
                id="tuners_max_beta"
                checked={absolute_max_beta ? true : false}
                handler={() =>
                  absoluteSwitchHandler({
                    name: "max_beta",
                    value: !absolute_max_beta,
                  })
                }
                text_on="ABSOLUTE"
                text_off="ABSOLUTE"
                size="big"
                grey={
                  absolute_max_beta === false && selected_type === ""
                    ? true
                    : !absolute_max_beta
                    ? true
                    : false
                }
              />
            </div>
            {/* <div className="tuners_list_card_slider">
              <div onClick={() => this.onSliderChange(activePortfolioID, 3)}>
                <div id={`beta${activePortfolioID}`} />
              </div>
            </div> */}
          </div>
        </div>
        <div className="tuners_absolute_msg">
          ABSOLUTE TUNERS : when absolute switch is turned on for a parameter,
          only that parameter will be used for optimization.
        </div>
      </div>
    );
  }
}

Tuners.propTypes = {
  activePortfolioID: Proptypes.oneOfType([Proptypes.number, Proptypes.string]),
  changeUIParams: Proptypes.func,
  optimization_params: Proptypes.object,
  securityUniverseActive: Proptypes.bool,
};
export default connect(
  ({
    create: {
      steps: {
        backendParams: { optimization_params },
        risk: { activePortfolioID },
        universeLite: { securityUniverseActive },
        tuners_absolute_selection: {
          selected_type,
          absolute_max_vol,
          absolute_min_return,
          absolute_max_beta,
        },
      },
    },
  }) => ({
    activePortfolioID,
    optimization_params,
    securityUniverseActive,

    selected_type,
    slected_obj: optimization_params[activePortfolioID],
    absolute_max_vol,
    absolute_min_return,
    absolute_max_beta,
  }),
  (dispatch) => ({
    changeUIParams: (ui_ixs, ui_value, id) =>
      dispatch({ type: "CHANGE_UI_PARAMS", payload: { ui_ixs, ui_value, id } }),
    absoluteSwitchHandler: ({ name, value }) => {
      dispatch({
        type: "CREATE_STEP_ABSOLUTE_SWITCH_HANDLER",
        payload: {
          name,
          value,
        },
      });
    },
  })
)(Tuners);



// WEBPACK FOOTER //
// ./src/components/pages/Create/Tuners.jsx